function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class AddMaxQuantity extends HTMLElement {
  constructor() {
    super();

    this.init();
    this.addEventListener("click", this.addToCart.bind(this));
  }

  init = async () => {
    this.getData();
    this.getinventoryQuantity();
    await this.getCart();
  };

  getData() {
    this.inventoryQuantity = parseInt(this.dataset.inventoryQuantity);
    this.loading = this.dataset.loading === "true" ? true : false;
    this.productId = this.dataset.productId;
    this.maxQuantity = parseFloat(this.dataset.quantity).toFixed();
  }

  async addToCart(e) {
    this.getData();

    const availability = await this.verifyAvailability();

    if (!availability) return;

    this.classList.add("loading");

    await this.addCartItems(this.productId, this.maxQuantity);

    await this.getCart();
  }

  showNotAvailableMessage(message) {
    const messageWrapper = document.querySelector("#max_quantity_not_allowed");
    const msessageInfo = messageWrapper.querySelector("p");
    msessageInfo.textContent = message;

    messageWrapper.classList.add("active");

    setTimeout(() => {
      messageWrapper.classList.remove("active");
    }, 3000);
  }

  async verifyAvailability() {
    let isAvailable = true;

    if (this.productId === "null") {
      isAvailable = false;
      this.showNotAvailableMessage("Producto no disponible");
    }

    if (this.inventoryQuantity == 0) {
      isAvailable = false;
      this.showNotAvailableMessage("Producto agotado");
    }

    await this.getCart();

    const productOnCart = this.cart.items.find(
      (item) => item.id == this.productId
    );

    if (productOnCart) {
      const productInventory = this.inventoryQuantityArray.find(
        (variant) => variant[0] == productOnCart.id
      );

      if (productInventory) {
        this.inventoryQuantity = productInventory[1];

        const addQty =
          parseInt(this.maxQuantity) + parseInt(productOnCart.quantity);

        if (addQty > this.inventoryQuantity) {
          this.showNotAvailableMessage(
            "La cantidad supera el inventario disponible"
          );
          isAvailable = false;
        }
      }
    }

    return isAvailable;
  }

  getCart = async () => {
    await fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        this.cart = data;
      })
      .catch((err) => {
        throw new Error(err);
      });
  };

  getinventoryQuantity() {
    this.inventoryQuantityArray = JSON.parse(
      this.querySelector('.inventoryQuantity[type="application/json"]')
        .textContent
    );
  }

  addCartItems = async (variantId, cant) => {
    try {
      const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: cant,
        }),
      });

      const response = await result.json();

      setTimeout(() => {
        showModal();
        this.classList.remove("loading");
      }, 500);

      return response;
    } catch (e) {
      return new Error("error no se pudo agregar al carrito");
    }
  };
}

customElements.define("add-max-quantity", AddMaxQuantity);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.colorLables = document.querySelectorAll(
      ".product-form__input label.color_options_label"
    );
    this.addEventListener("change", this.onVariantChange);
    this.getVariantData();
    this.getFirstVariantSelectedData();
    this.setSizePrice(this.currentVariant);
    this.setAvailabilityMaxQuantity();
    this.setSelectedOptionsTitles();
    this.getProductData();
    this.setBorderColor();
    this.setOfferTag();
  }

  onVariantChange(event) {
    this.resetFormVariantChange();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateMedia();
    this.changeColor(event);
    this.setReference();
    this.setSizePrice(this.currentVariant);
    this.setAvailabilityMaxQuantity();
    this.setSelectedOptionsTitles();
    this.setBorderColor();

    // console.log("currentVariant:", {
    //   currentVariant: this.currentVariant,
    // });

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  setSizePrice(variant) {
    const sizeOptions =
      document.querySelectorAll(".label-option.size_options_label") || [];

    // console.log(sizeOptions);

    sizeOptions.forEach((option) => {
      option.querySelector(".price").textContent = "--";
      option.querySelector(".unit_price").textContent = "--";
    });

    if (variant) {
      this.getVariantData().forEach((variantItem) => {
        // console.log("variantItem", variantItem);

        if (variantItem.option2 === variant.option2) {
          sizeOptions.forEach((option) => {
            if (
              variantItem.option1.toUpperCase() ===
              option.dataset.optionValue.toUpperCase()
            ) {
              let optionPrice = (variantItem.price / 100).toFixed();
              let optionCompareAtPrice = variantItem.compare_at_price
                ? (variantItem.compare_at_price / 100).toFixed()
                : null;

              let sizeAmount = parseFloat(
                option.dataset.optionValue.split(" ")[0]
              );

              if (
                option.dataset.optionValue.split(" ")[1]?.toUpperCase() ===
                "MTL"
              ) {
                sizeAmount = sizeAmount * 100;
              }

              option.querySelector(
                ".price"
              ).textContent = `$${new Intl.NumberFormat("de-DE", {
                maximumFractionDigits: 0,
              }).format(optionPrice)}`;

              if (optionCompareAtPrice) {
                option.querySelector(".price_compare").style.display = "block";
                option.querySelector(
                  ".price_compare"
                ).textContent = `$${new Intl.NumberFormat("de-DE", {
                  maximumFractionDigits: 0,
                }).format(optionCompareAtPrice)}`;
              } else {
                option.querySelector(".price_compare").style.display = "none";
              }

              if (optionPrice && sizeAmount) {
                const unitPrice = optionPrice / sizeAmount;

                option.querySelector(
                  ".unit_price"
                ).textContent = `($${new Intl.NumberFormat("de-DE", {
                  maximumFractionDigits: 0,
                }).format(unitPrice)} por cm)`;
              }
            }
          });
        }
      });
    }
  }

  setReference() {
    const reference = document.querySelector(
      `#shopify-section-${this.dataset.section} .reference`
    );
    if (this.currentVariant) {
      const value = variantsMetafields.filter(
        (variant) => variant.id == this.currentVariant.id
      );
      reference.textContent = value[0].reference;
    } else {
      reference.textContent = "";
    }
  }

  setAvailabilityMaxQuantity() {
    const addMaxQuantity = document.getElementById("add_max_quantity");

    if (!addMaxQuantity) return;

    if (addMaxQuantity.querySelector(".price")) {
      addMaxQuantity.querySelector(".price").textContent = "--";
    }

    if (this.currentVariant) {
      const currenVariantPrice = this.currentVariant.price / 100;
      const maxQty = parseInt(addMaxQuantity.dataset.quantity);
      const currenVariantMaxQtyPrice = currenVariantPrice * maxQty;
      const currenVariantMaxQtyUnitPrice =
        this.currentVariant.price /
        100 /
        parseInt(this.currentVariant.option1.split(" ")[0]);

      if (addMaxQuantity.querySelector(".price")) {
        addMaxQuantity.querySelector(
          ".price"
        ).textContent = `$${new Intl.NumberFormat("de-DE", {
          maximumFractionDigits: 0,
        }).format(currenVariantMaxQtyPrice)}`;
      }

      if (addMaxQuantity.querySelector(".unit_price")) {
        addMaxQuantity.querySelector(
          ".unit_price"
        ).textContent = `($${new Intl.NumberFormat("de-DE", {
          maximumFractionDigits: 0,
        }).format(currenVariantMaxQtyUnitPrice)} por cm)`;
      }
    }

    if (this.currentVariant) {
      addMaxQuantity.dataset.productId = this.currentVariant.id;
    } else {
      addMaxQuantity.dataset.productId = null;
    }

    addMaxQuantity.disabled =
      !this.currentVariant || this.currentVariant.available === false
        ? true
        : false;
  }

  setSelectedOptionsTitles() {
    if (!this.currentVariant) return;

    this.currentVariant.options.map((option, index) => {
      const label = document.querySelector(
        `.form_label_titles.style_2 .value-${index + 1}`
      );

      if (!label) return;

      label.textContent = option;
    });
  }

  changeColor(event) {
    // const colorValue = this.querySelector('input[name="Color"][checked]').value;
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;

    const colorOptions = $(".product-form__input.variant_picker.color_options");

    if (event.target.dataset.option === "Color") {
      $(colorOptions)
        .find(".color_option_selected .option_title")
        .text(event.target.value);
      $(colorOptions).find(".color_options_list.open").removeClass("open");
      $(colorOptions).find(".color_option_selected.open").removeClass("open");
    }

    if (this.currentVariant && this.currentVariant.featured_image) {
      $(colorOptions)
        .find(".color_option_selected .img")
        .css("visibility", "visible");
      $(colorOptions)
        .find(".color_option_selected .img img")
        .attr("src", this.currentVariant.featured_image.src);
    } else {
      $(colorOptions)
        .find(".color_option_selected .img")
        .css("visibility", "hidden");
      $(colorOptions).find(".color_option_selected .img img").attr("src", "");
    }

    window.scrollTo(scrollY, scrollX);
  }

  resetFormVariantChange() {
    $("#by_demand_form").hide();
    $(".product-form__input.product-form__quantity").show();
    $('form[data-type="add-to-cart-form"]').show();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const optionsValue = [...this.options]
      .map((option) => option.value)
      .join(" / ");

    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.title.toUpperCase() === optionsValue.toUpperCase();
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    const api = $(".product_slider").slick("getSlick");

    api.slickGoTo(this.currentVariant.featured_media.position - 1);

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent
        .querySelector("li.product__media-item")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    // spec: specs/fix-bug-cantidad-duplicada-carrito.md
    // getElementById returns only the first match, preventing duplicate-ID forms from receiving the change event
    const mainForm = document.getElementById(`product-form-${this.dataset.section}`);
    const installmentForm = document.getElementById('product-form-installment');
    [mainForm, installmentForm].filter(Boolean).forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButtonText.textContent = text;
    } else if (!addButton.classList.contains('loading')) {
      // spec: specs/fix-bug-cantidad-duplicada-carrito.md
      // Only re-enable if no fetch is in flight; prevents race condition with renderProductInfo
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    if (this.querySelector('.productVariants[type="application/json"]')) {
      this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('.productVariants[type="application/json"]')
            .textContent
        );

      return this.variantData;
    } else {
      return null;
    }
  }

  getProductData() {
    if (this.querySelector('.productData[type="application/json"]')) {
      this.product =
        this.product ||
        JSON.parse(
          this.querySelector('.productData[type="application/json"]')
            ?.textContent
        );

      return this.product;
    } else {
      return null;
    }
  }

  getFirstVariantSelectedData() {
    if (this.variantData) {
      this.currentVariant =
        this.currentVariant ||
        this.variantData?.find((variant) => variant.available) ||
        this.variantData[0];
    }
  }

  setBorderColor() {
    this.colorLables?.forEach((color) => {
      color.style.border = "none";

      if (
        this.product.options.length > 1 &&
        color.dataset.optionValue.toUpperCase() ===
          this.currentVariant.option2.toUpperCase()
      ) {
        color.style.border = "0.2rem solid #000000";
      } else if (
        this.product.options.length === 1 &&
        this.product.options[0].toUpperCase() === "COLOR" &&
        color.dataset.optionValue.toUpperCase() ===
          this.currentVariant.option1.toUpperCase()
      ) {
        color.style.border = "0.2rem solid #000000";
      }
    });
  }

  setOfferTag() {
    const tagsOffer = document.querySelector(".offer.size_options_label.tag");

    if (tagsOffer) {
      const productCollections = tagsOffer?.querySelector(
        '.productCollections[type="application/json"]'
      );
      const collectionArray = JSON.parse(productCollections.textContent).map(
        (item) => item.handle.toUpperCase()
      );

      if (tagsDictionary) {
        tagsDictionary.forEach((item) => {
          if (collectionArray.includes(item.key.toUpperCase())) {
            tagsOffer.textContent = item.text;

            if (item.color) {
              tagsOffer.style.color = item.color;
            }
          }
        });
      }
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.variantItem = document.querySelectorAll(
      ".product-form__input .custom-select__list_item--Color"
    );

    setTimeout(() => {
      this.setBackground();
    }, 300);
  }

  setBackground() {
    this.variantItem.forEach((option) => {
      this.getVariantData().map((variant) => {
        if (
          variant.public_title
            .toUpperCase()
            .includes(option.dataset.value.toUpperCase())
        ) {
          if (variant.featured_image) {
            option.querySelector("img").src = variant.featured_image.src;
          } else {
            option.querySelector("img").style.display = "none";
          }
        }
      });
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
    });
  }
}

customElements.define("variant-radios", VariantRadios);

function validateContact() {
  let validate = $("#terms").is(":checked");

  if (!validate) {
    $("#modalTerms").css("display", "block");
  }
}
$(document).ready(function ($) {
  $("#close-modal-terms").click(function () {
    $("#modalTerms").css("display", "none");
  });

  setTimeout(function () {
    $(".preload").remove();
  }, 2000);
});

window.onclick = function (event) {
  if (event.target.id == "modalTerms") {
    $("#modalTerms").css("display", "none");
  }
};

window.helpers = {};

window.helpers.listAllEventListeners = function (selector) {
  const allElements = Array.prototype.slice.call(
    document.querySelectorAll(selector)
  );
  allElements.push(document);
  allElements.push(window);

  const types = [];

  for (let ev in window) {
    if (/^on/.test(ev)) types[types.length] = ev;
  }

  let elements = [];
  for (let i = 0; i < allElements.length; i++) {
    const currentElement = allElements[i];
    for (let j = 0; j < types.length; j++) {
      if (typeof currentElement[types[j]] === "function") {
        elements.push({
          node: currentElement,
          type: types[j],
          func: currentElement[types[j]].toString(),
        });
      }
    }
  }

  return elements.sort(function (a, b) {
    return a.type.localeCompare(b.type);
  });
};

class AsideMenu extends HTMLElement {
  constructor() {
    super();

    this.openDrawerOnHover();

    this.querySelectorAll("[close-drawer]").forEach((element) => {
      element.addEventListener("click", this.closeDrawer);
    });
  }

  openDrawerOnHover() {
    if (document.querySelectorAll("[open-drawer]")) {
      document.querySelectorAll("[open-drawer]").forEach((item) => {
        item.addEventListener("mouseenter", (e) => {
          this.openDrawer();
        });
      });
    }
  }

  openDrawer() {
    document
      .getElementById("aside_menu_alternative")
      .setAttribute("open", true);
  }

  closeDrawer() {
    document.getElementById("aside_menu_alternative").removeAttribute("open");
  }
}

customElements.define("aside-menu-alternative", AsideMenu);

// Search form by category component
class SearchByCollection extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.querySearch = this.querySelector(`#${this.dataset.selector}`);

    this.terms = this.querySelector("#terms");
    this.collection = this.querySelector("#collection");

    this.setInitialValue();

    this.form.addEventListener("change", this.setQueryValue.bind(this));
  }

  setInitialValue() {
    const params = new URLSearchParams(window.location.href);
    if (params.get("terms")) {
      this.terms.value = params.get("terms");
    }

    if (params.get("collection")) {
      this.collection.value = params.get("collection");
    }
  }

  setQueryValue(event) {
    const formData = new FormData(this.form);

    const queryValue =
      formData.get("collection") === "all"
        ? `${formData.get("terms")}`
        : `${formData.get("collection")} ${formData.get("terms")}`;

    this.querySearch.value = queryValue;
  }
}

customElements.define("search-by-collection", SearchByCollection);

// Function for open category menu at hover
const summaryOpenWithHoverCategories = document.querySelectorAll(
  ".details-open-with-hover"
);

if (summaryOpenWithHoverCategories.length > 0) {
  summaryOpenWithHoverCategories.forEach((item) => {
    item.addEventListener("mouseenter", (e) => {
      e.target.setAttribute("open", "");
    });
    item.addEventListener("mouseleave", (e) => {
      e.target.removeAttribute("open");
    });
  });
}

const summaryOpenWithClick = document.querySelectorAll(
  ".details-header-menu.details-open-with-click"
);

if (summaryOpenWithClick.length > 0) {
  summaryOpenWithClick.forEach((item) => {
    item.addEventListener("click", (e) => {
      summaryOpenWithClick.forEach((item) => {
        if (item.getAttribute("id") !== e.currentTarget.getAttribute("id")) {
          item.removeAttribute("open");
        }
      });

      e.target.setAttribute("open", "");
    });
  });
}

const detailsMobileOpenWithClick = document.querySelectorAll(
  ".details-menu-mobile.details-open-with-click"
);

if (detailsMobileOpenWithClick.length > 0) {
  detailsMobileOpenWithClick.forEach((item) => {
    item.addEventListener("click", (e) => {
      detailsMobileOpenWithClick.forEach((item) => {
        if (item.getAttribute("id") !== e.currentTarget.getAttribute("id")) {
          item.removeAttribute("open");
        }
      });

      e.target.setAttribute("open", "");
    });
  });
}
